import {Component, ViewChild, Input, Output, EventEmitter} from '@angular/core';
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {ClientFundingInformation, IClientModel} from '../../../models/clients/clients.model';
import {ClientLocationsModel} from "../../../models/client-locations/client-locations.model";
import {StaticDataService} from "../../../services/StaticData.service";
import {AreaCodesService} from "../../../models/area-codes/area-codes.service";
import {AreaCodesModel} from "../../../models/area-codes/area-codes.model";
import {ClientsService} from '../../../models/clients/clients.service';
import {DebtsService} from '../../../models/debts/debts.service';
import {DebtsModel} from '../../../models/debts/debts.model';
import {SpeedCalculatorComponent} from "./speed-calculator/speed-calculator.component";


@Component({
    selector: 'funding-information',
    templateUrl: 'funding-information.template.html',
    exportAs: 'funding-information'
})
export class FundingInformationComponent {
    @Input('client')
    @Output('client')
    public client: IClientModel = {
        mailing_location: new ClientLocationsModel(),
        business_location: new ClientLocationsModel(),
        prior_advances: 0
    };


    @Input('clientId')
    public clientId;

    public fundingInformation = new ClientFundingInformation();

    @Input('debt')
    public debt = new DebtsModel();

    constructor(
        private clientsService: ClientsService,
        private debtsService: DebtsService,
        private modalService:NgbModal
    ) {
    }

    ngOnInit() {

        if (this.clientId) {
            this.clientsService.getFundingInformation(this.clientId)
                .subscribe((res) => {
                    this.fundingInformation = res.data;
                });

            if (!this.debt.id) {
                this.debtsService.getOneByClient(this.clientId)
                    .subscribe((res) => {
                        this.debt = res.data;
                    })
            }
        }

    }

    ngOnChanges(changes) {
        this.ngOnInit();
    }

    public showSpeedCalculator() {
        const modalRef = this.modalService.open(SpeedCalculatorComponent);
        modalRef.componentInstance.debt = this.debt;
        modalRef.componentInstance.clientId = this.clientId;
    }

}



// WEBPACK FOOTER //
// ./src/app/modules/client-forms/funding-information/funding-information.component.ts